import { merge } from 'lodash';
import { getCommonStyle } from './styleCommon';
import { getAxesStyles } from './panel/axes';
import crosshair from './panel/crosshair';
import { getGridStyles } from './panel/grid';
import label from './panel/label';
import { getBorderStyles } from './panel/border';

const commonSessionBreak = getCommonStyle('sessionBreak');

export function getPanelStyles() {

	const axes = getAxesStyles();

	const sessionBreakStyle = merge({}, commonSessionBreak, {
		background: {
			color: 'rgba(0, 0, 0, 0.02)'
		}
	});

	return {
		...axes,
		border: getBorderStyles(),
		crosshair,
		grid: getGridStyles(),
		label,
		margin: {
			bottom: 0,
			top: 0
		},
		padding: {
			bottom: 35,
			left: 0,
			right: 55,
			top: 0
		},
		preMarket: {
			background: {
				color: null
			},
			border: {
				lineDash: null,
				color: null,
				width: null
			}
		},
		postMarket: {
			background: {
				color: null
			},
			border: {
				lineDash: null,
				color: null,
				width: null
			}
		},
		sessionBreak: sessionBreakStyle
	};
}
